import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAIUsage } from '@services/requests/helpdeskAI';

export const ThunkGetTenantAIUsage = createAsyncThunk(
  'helpdeskAI/getTenantAIUsage',
  () => getAIUsage(),
);

export default {};
